import { FC, ReactNode } from 'react';

// To change breakpoints for main grid, also alter in cardUtils (getColSpan) and ProjectCards for Dashboard

export const CardsLayoutGrid: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-[15px] page-side-padding">
    {children}
  </div>
);

export const FeedLayoutGrid: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="grid grid-cols-1 lg:grid-cols-8 gap-[15px]">{children}</div>
);

export const SearchResultsLayoutGrid: FC<{ children: ReactNode }> = ({
  children,
}) => (
  <div className="grid grid-cols-1 row-[1] lg:row-auto lg:grid-cols-3 gap-[15px] w-[350px] grid-rows-[auto_auto_1fr]">
    {children}
  </div>
);

export default CardsLayoutGrid;
